import { StateService } from '@uirouter/angular';
import { Injectable } from '@angular/core';
import { GfTranslateService } from '../../core/services/core.translate.service';
import * as _ from 'lodash';

@Injectable()
export class NotificationHistoryHelper {
  constructor(private stateService: StateService, private translateService: GfTranslateService) {}

  getSortFields() {
    return {
      sendDate: this.translateService.translate('Date'),
      section: this.translateService.translate('Section'),
      subject: this.translateService.translate('Subject'),
      user: this.translateService.translate('User')
    };
  }

  getAnyFilterObj() {
    return { id: '', label: this.translateService.translate('Any'), defaultSelected: true };
  }

  getCustomFilterObj() {
    return { id: null, label: this.translateService.translate('Custom'), defaultSelected: false };
  }

  getSectionElements() {
    const ret = [
      this.getAnyFilterObj(),
      { id: 'site', label: this.translateService.translate('Site') },
      { id: 'project', label: this.translateService.translate('Project') },
      { id: 'trackeritem', label: this.translateService.translate('Tracker Item') },
      { id: 'trackersprint', label: this.translateService.translate('Sprint') }
    ];

    if (this.stateService.params.unixName) {
      ret.splice(1, 1);
    }

    return ret;
  }

  getDateRangeElements() {
    return [
      this.getAnyFilterObj(),
      { id: '-7 days', label: this.translateService.translate('This Week') },
      { id: '-15 days', label: this.translateService.translate('Last 15 days') },
      { id: '-30 days', label: this.translateService.translate('Last 30 days') },
      { id: '-60 days', label: this.translateService.translate('Last 60 days') },
      { id: '-90 days', label: this.translateService.translate('Last 90 days') },
      { id: '-365 days', label: this.translateService.translate('Last year') }
    ];
  }

  getBaseFilters() {
    const any = this.getAnyFilterObj();

    return [
      { alias: 'section', fieldName: this.translateService.translate('Section'), value: any, fieldType: 1, isExtraField: false, fieldElements: this.getSectionElements() },
      { alias: 'user', fieldName: this.translateService.translate('User'), value: '', fieldType: 4, isExtraField: false },
      { alias: 'subject', fieldName: this.translateService.translate('Subject'), value: '', fieldType: 4, isExtraField: false },
      { alias: 'dateRange', fieldName: this.translateService.translate('Date Range'), value: any, fieldType: 1, isExtraField: false, fieldElements: this.getDateRangeElements() },
      { alias: 'dateStart', fieldName: this.translateService.translate('Start Date'), value: '', fieldType: 9, isExtraField: false },
      { alias: 'dateEnd', fieldName: this.translateService.translate('End Date'), value: '', fieldType: 9, isExtraField: false }
    ];
  }

  getSelectedElement(filter: any) {
    const val = _.get(this.stateService.params, filter.alias, false) || '';
    const elem = filter.fieldElements.find((e: any) => e.id === val) || filter.fieldElements.find((e: any) => e.defaultSelected);
    return elem;
  }

  setFiltersFromStateParams(filters: any[]) {
    return filters.map((f: any) => {
      switch (f.fieldType) {
        case 1: // list
          f.value = this.getSelectedElement(f);
          break;

        default: // text/other
          f.value = _.get(this.stateService.params, f.alias, false) || '';
          break;
      }
      return f;
    });
  }
}
